"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAllowedRoutes = exports.refreshAdmin = void 0;
const refreshAdmin = (admin) => {
    return {
        type: 'refresh-admin',
        admin: admin
    };
};
exports.refreshAdmin = refreshAdmin;
const setAllowedRoutes = (allowedRoutes) => {
    return {
        type: 'setAllowedRoutes',
        allowedRoutes: allowedRoutes
    };
};
exports.setAllowedRoutes = setAllowedRoutes;
